import { render, staticRenderFns } from "./dept-sales.vue?vue&type=template&id=2a322a1d&scoped=true"
import script from "./dept-sales.vue?vue&type=script&lang=js"
export * from "./dept-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a322a1d",
  null
  
)

export default component.exports